import Configuration from "../core/foundation/Configuration";
import store from "../core/state/Store";
import { CustomConfigSection } from "../core/state/system/Menu";
import {
    setDisplayMenuOpen,
    setPrintMenuOpen,
} from "../core/state/system/UIConfiguration";
import { MenuItem, MenuItemIconType } from "../core/types/system/MenuItem";
import Welcome from "../routes/Welcome";
import Version9 from "../routes/Version9";
import Version10 from "../routes/Version10";
import Recommendations from "../routes/Recommendations";
import Users from "../routes/Users";
import UserRoles from "../routes/UserRoles";
import ManageSchool from "../routes/ManageSchool";
import Settings from "../routes/Settings";
import YearLevels from "../routes/YearLevels";
import Students from "../routes/Students";
import Teachers from "../routes/Teachers";
import Rooms from "../routes/Rooms";
import Areas from "../routes/Areas";
import Faculties from "../routes/Faculties";
import Subjects from "../routes/Subjects";
import FileExplorer from "../routes/FileExplorer";
import Exports from "../routes/Exports";
import Organisers from "../routes/Organisers";
import PublishedTimetables from "../routes/PublishedTimetables";
import Integrations from "../routes/Integrations";
import Applications from "../routes/Applications";
import Approvals from "../routes/Approvals";
import MessageLogs from "../routes/MessageLogs";
import Logs from "../routes/Logs";
import LogArchives from "../routes/LogArchives";
import LoginStats from "../routes/LoginStats";

export const menuData: MenuItem[] = [
    {
        id: "home",
        name: "Home Page",
        icon: "home",
        iconType: MenuItemIconType.None,
        path: "/",
        component: <Welcome />,
        children: [],
        order: 1,
    },
    {
        id: "users",
        name: "Users",
        icon: "1",
        iconType: MenuItemIconType.Info,
        children: [
            {
                id: "manageUsers",
                name: "Manage Users",
                icon: "A",
                iconType: MenuItemIconType.Info,
                path: "/users",
                component: <Users />,
                children: [],
                order: 1,
            },
            {
                id: "userRoles",
                name: "User Roles",
                icon: "B",
                iconType: 1,
                path: "/userRoles",
                component: <UserRoles />,
                children: [],
                order: 2,
            },
        ],
        order: 2,
    },
    {
        id: "configuration",
        name: "Configuration",
        icon: "2",
        iconType: MenuItemIconType.Info,
        children: [
            {
                id: "manageSchool",
                name: "Manage School",
                icon: "A",
                iconType: MenuItemIconType.Info,
                path: "/manageSchool",
                component: <ManageSchool />,
                children: [],
                order: 1,
            },
            {
                id: "settings",
                name: "Settings",
                icon: "B",
                iconType: MenuItemIconType.Info,
                path: "/settings",
                component: <Settings />,
                children: [],
                order: 2,
            },
        ],
        order: 3,
    },
    {
        id: "operations",
        name: "Operations",
        icon: "3",
        iconType: MenuItemIconType.Info,
        children: [
            {
                id: "yearlevels",
                name: "Year Levels",
                icon: "A",
                iconType: MenuItemIconType.Info,
                path: "/yearLevels",
                component: <YearLevels />,
                children: [],
                order: 1,
            },
            {
                id: "students",
                name: "Students",
                icon: "B",
                iconType: MenuItemIconType.Info,
                path: "/students",
                component: <Students />,
                children: [],
                order: 1,
            },
            {
                id: "teachers",
                name: "Teachers",
                icon: "C",
                iconType: MenuItemIconType.Info,
                path: "/teachers",
                component: <Teachers />,
                children: [],
                order: 2,
            },
            {
                id: "rooms",
                name: "Rooms",
                icon: "D",
                iconType: MenuItemIconType.Info,
                path: "/rooms",
                component: <Rooms />,
                children: [],
                order: 3,
            },
            {
                id: "areas",
                name: "Duty Areas",
                icon: "E",
                iconType: MenuItemIconType.Info,
                path: "/areas",
                component: <Areas />,
                children: [],
                order: 4,
            },
        ],
        order: 4,
    },
    {
        id: "curriculum",
        name: "Curriculum",
        icon: "4",
        iconType: MenuItemIconType.Info,
        children: [
            {
                id: "faculties",
                name: "Faculties",
                icon: "A",
                iconType: MenuItemIconType.Info,
                path: "/faculties",
                component: <Faculties />,
                children: [],
                order: 1,
            },
            {
                id: "subjects",
                name: "Subjects",
                icon: "B",
                iconType: MenuItemIconType.Info,
                path: "/subjects",
                component: <Subjects />,
                children: [],
                order: 2,
            },
        ],
        order: 5,
    },
    {
        id: "data",
        name: "Data Management",
        icon: "5",
        iconType: MenuItemIconType.Processing,
        children: [
            {
                id: "explorer",
                name: "File Explorer",
                icon: "A",
                iconType: MenuItemIconType.Processing,
                path: "/explorer",
                component: <FileExplorer />,
                children: [],
                order: 1,
            },
            {
                id: "exports",
                name: "Export Bundles",
                icon: "B",
                iconType: MenuItemIconType.Processing,
                path: "/exports",
                component: <Exports />,
                children: [],
                order: 2,
            },
        ],
        order: 6,
    },
    {
        id: "organiser",
        name: "Daily Organiser",
        icon: "6",
        iconType: MenuItemIconType.Processing,
        children: [
            {
                id: "organisers",
                name: "Organisers",
                icon: "A",
                iconType: MenuItemIconType.Processing,
                path: "/organisers",
                component: <Organisers />,
                children: [],
                order: 1,
            },
            {
                id: "publishedtimetables",
                name: "Published Timetables",
                icon: "B",
                iconType: MenuItemIconType.Processing,
                path: "/timetables",
                component: <PublishedTimetables />,
                children: [],
                order: 2,
            },
        ],
        order: 7,
    },
    {
        id: "integrations",
        name: "Integrations",
        icon: "7",
        iconType: MenuItemIconType.Processing,
        children: [
            {
                id: "siffliss",
                name: "SIF/LISS Integrations",
                icon: "A",
                iconType: MenuItemIconType.Processing,
                path: "/siffliss",
                component: <Integrations />,
                children: [],
                order: 1,
            },
            {
                id: "applications",
                name: "Application Integrations",
                icon: "B",
                iconType: MenuItemIconType.Processing,
                path: "/applications",
                component: <Applications />,
                children: [],
                order: 2,
            },
        ],
        order: 8,
    },
    {
        id: "approvals",
        name: "Approvals",
        icon: "8",
        iconType: MenuItemIconType.Processing,
        path: "/approvals",
        component: <Approvals />,
        children: [],
        order: 9,
    },
    {
        id: "logging",
        name: "Logging",
        icon: "9",
        iconType: MenuItemIconType.Reports,
        children: [
            {
                id: "messagingLogs",
                name: "Message Logs",
                icon: "A",
                iconType: MenuItemIconType.Reports,
                path: "/messagelogs",
                component: <MessageLogs />,
                children: [],
                order: 1,
            },
            {
                id: "accessLogs",
                name: "Access Logs",
                icon: "B",
                iconType: MenuItemIconType.Reports,
                path: "/accesslogs",
                component: <Logs />,
                children: [],
                order: 2,
            },
            {
                id: "logArchives",
                name: "Log Archives",
                icon: "C",
                iconType: MenuItemIconType.Reports,
                path: "/logarchives",
                component: <LogArchives />,
                children: [],
                order: 3,
            },
            {
                id: "loginStats",
                name: "Login Statistics",
                icon: "D",
                iconType: MenuItemIconType.Reports,
                path: "/loginstats",
                component: <LoginStats />,
                children: [],
                order: 4,
            },
        ],
        order: 10,
    },
    {
        id: "recommendations",
        name: "Recommendations",
        iconType: 1,
        path: "/recommendations",
        component: <Recommendations />,
        children: [],
        order: 9999999,
        hidden: true,
    },
    {
        id: "version9",
        name: "Version 9",
        iconType: 1,
        path: "/version9",
        component: <Version9 />,
        children: [],
        order: 9999999,
        hidden: true,
    },
    {
        id: "version10",
        name: "Version 10",
        iconType: 1,
        path: "/version10",
        component: <Version10 />,
        children: [],
        order: 9999999,
        hidden: true,
    },
];

export const generalSettings: MenuItem[] = [
    {
        id: "help",
        name: "Help & Support",
        icon: "help",
        iconType: 1,
        path: "",
        onClick: () => {
            window["_elev"].openHome();
        },
        component: null,
        children: [],
        order: 1,
    },
    {
        id: "display",
        name: "Display Settings",
        icon: "desktop_windows",
        iconType: 1,
        path: "",
        onClick: () => {
            store.dispatch(setDisplayMenuOpen(true));
        },
        component: null,
        children: [],
        order: 2,
    },
    {
        id: "help",
        name: "Print",
        icon: "print",
        iconType: 1,
        path: "",
        onClick: () => {
            store.dispatch(setPrintMenuOpen(true));
        },
        component: null,
        children: [],
        order: 3,
    },
];

export const configSettings: MenuItem[] = [
    {
        id: "user_accounts",
        name: "User Accounts",
        icon: "groups",
        iconType: 1,
        path: Configuration.managementPath + "/Interface/Users",
        component: null,
        children: [],
        order: 1,
    },
    {
        id: "user_roles",
        name: "User Roles",
        icon: "vpn_key",
        iconType: 1,
        path: Configuration.managementPath + "/Interface/UserRoles",
        component: null,
        children: [],
        order: 2,
    },
    {
        id: "sso",
        name: "SSO",
        icon: "fingerprint",
        iconType: 1,
        path:
            Configuration.managementPath + "/Interface/Settings?tab=tabSAMLSSO",
        component: null,
        children: [],
        order: 3,
    },
    {
        id: "security",
        name: "Security",
        icon: "lock",
        iconType: 1,
        path:
            Configuration.managementPath +
            "/Interface/Settings?tab=tabSecurity",
        component: null,
        children: [],
        order: 4,
    },
    {
        id: "email_settings",
        name: "Email Settings",
        icon: "email",
        iconType: 1,
        path: Configuration.managementPath + "/Interface/Settings?tab=tabEmail",
        component: null,
        children: [],
        order: 5,
    },
];

export const customConfigSections: CustomConfigSection[] = [];
